<div class="modal-content add-driver-dialog" *transloco="let t; prefix: 'driverInformation'">
  <div class="modal-header">
    <h5 class="modal-title">{{ t('addDialog.title') }}</h5>
    <button type="button" class="btn-close" [attr.aria-label]="'common.close' | transloco" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="driverForm">
      <div class="photo-placeholder text-center mb-2">
        <div class="rounded-circle mx-auto d-flex justify-content-center align-items-center overflow-hidden">
          @if (photoUrl) {
            <img [src]="photoUrl" [alt]="t('addDialog.driverPhotoAlt')" class="profile-img">
          } @else {
            <img [src]="placeholder" [alt]="t('addDialog.placeholderPhotoAlt')" class="profile-img">
          }
        </div>
        <label for="addPhoto" class="text-primary change-photo-label mt-2">{{ t('fields.changePhoto') }}</label>
        <input type="file" id="addPhoto" name="profilePicture" hidden (change)="onAddDriverPhoto($event)">
      </div>

      <div class="row g-3">
        <div class="col-12">
          <app-account-selector (accountChanged)="onSelectAccount($event)" [isFilter]="false"
          [positionOffset]="'-115,15'"></app-account-selector>
        </div>
        <div class="col-md-6">
          <label class="form-label">{{ t('fields.firstName') }} <span class="required">*</span></label>
          <input type="text" name="firstName" formControlName="firstName" class="form-control" required>
          <app-form-error-message [control]="driverForm.get('firstName')!" [errorMessage]="getErrorMessage('firstName')"
            [formSubmitted]="submitted">
          </app-form-error-message>
        </div>
        <div class="col-md-6">
          <label class="form-label">{{ t('fields.lastName') }} <span class="required">*</span></label>
          <input type="text" name="lastName" formControlName="lastName" class="form-control" required>
          <app-form-error-message [control]="driverForm.get('lastName')!" [errorMessage]="getErrorMessage('lastName')"
            [formSubmitted]="submitted">
          </app-form-error-message>
        </div>
        <div class="col-12">
          <app-flatpickr-date-picker
            [label]="t('fields.dateOfBirth')"
            [(value)]="dob"
            [required]="true"
            maxDate="today"
            [yearsAhead]="0"
            [allowPastDates]="true">
          </app-flatpickr-date-picker>
        </div>
        <div class="col-12">
          <div class="d-flex gap-2">
            <label class="radio-container d-flex">
              <input type="radio" name="passport" class="radio-input" (change)="updatePlaceholder('ID')" checked>
              <div class="custom-radio"></div>
              <span class="form-label">{{ t('fields.id') }}</span>
            </label>
            <label class="radio-container d-flex">
              <input type="radio" name="passport" class="radio-input" (change)="updatePlaceholder('Passport')">
              <div class="custom-radio"></div>
              <span class="form-label">{{ t('fields.passport') }}</span>
            </label>
            <span class="required">*</span>
          </div>

          <input type="text" name="idNumber" formControlName="idNumber" class="form-control"
            [ngClass]="alertMessage && oldIdNumber == this.driverForm.get('idNumber')?.value ?'invalid-input' :''"
            [placeholder]="placeholderText" required>
            <app-form-error-message [control]="driverForm.get('idNumber')!" [errorMessage]="getErrorMessage('idNumber')"
              [formSubmitted]="submitted">
            </app-form-error-message>
            <app-form-error-message [isEnabled]="!!alertMessage && oldIdNumber == this.driverForm.get('idNumber')?.value"
              [errorMessage]="alertMessage" [formSubmitted]="submitted">
            </app-form-error-message>
          </div>
          <div class="col-12">
            <label class="form-label">{{ t('fields.phoneNumber') }} <span class="required">*</span></label>
            <input type="tel" name="phoneNumber" formControlName="phoneNumber" class="form-control" required>
            <app-form-error-message [control]="driverForm.get('phoneNumber')!"
              [errorMessage]="getErrorMessage('phoneNumber')" [formSubmitted]="submitted">
            </app-form-error-message>
          </div>
          <div class="col-12">
            <label class="form-label">{{ t('fields.altPhoneNumber') }}</label>
            <input type="tel" name="altPhoneNumber" formControlName="altPhoneNumber" class="form-control">
            <app-form-error-message [control]="driverForm.get('altPhoneNumber')!"
              [errorMessage]="getErrorMessage('altPhoneNumber')" [formSubmitted]="submitted">
            </app-form-error-message>
          </div>
          <div class="col-12">
            <label class="form-label">{{ t('fields.email') }} <span class="required">*</span></label>
            <input type="email" name="email" formControlName="email" class="form-control" required>
            <app-form-error-message [control]="driverForm.get('email')!" [errorMessage]="getErrorMessage('email')"
              [formSubmitted]="submitted">
            </app-form-error-message>
          </div>
          <div class="col-12">
            <label class="form-label">{{ t('fields.address') }} <span class="required">*</span></label>
            <input type="text" name="address" formControlName="address" class="form-control" required>
            <app-form-error-message [control]="driverForm.get('address')!" [errorMessage]="getErrorMessage('address')"
              [formSubmitted]="submitted">
            </app-form-error-message>
          </div>
        </div>
        <div class="action-group my-4">
          <div class="action-buttons d-flex justify-content-between gap-4">
            <button type="button" class="btn btn-outline-danger flex-grow-1 cancel-btn" (click)="closeModal()">{{ 'common.cancel' | transloco }}</button>
            <button type="button"
              class="btn btn-danger flex-grow-1 btn-update-driver d-flex justify-content-center align-items-center position-relative gap-2 add-btn"
              [disabled]="!driverForm.valid || !dob || isLoading"
              (click)="onSubmitDriverForm()">
              @if (isLoading) {
                <span class="spinner-border"></span>
              }
              @if (!isLoading) {
                <span> {{ hasFleetManagerRole ? ('common.next' | transloco) : t('addDriver') }}</span>
              }
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>